
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/wixData/components/collectionsSection/collectionsSection.scss.css.virtualfile';
        module.exports = {"sectionHeader":"_sectionHeader_zwhoj_1"};